import React, { useEffect, useState } from "react";
import "./nujobsNotifications.scss";
import { List, Button, Empty } from "antd";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";
import { useNavigate } from "react-router-dom";

function NuJobsNotifications() {

    const { incompleteJDs,nuJobsGetIncompleteJds,nuJobsDisardIncompleteJd } = useNuJobDetailsStore(); 
    const navigate = useNavigate();
    useEffect(() => {
        nuJobsGetIncompleteJds()
        //console.log("notification JDs",incompleteJDs)
    }, []);

    const handleViewJob = (job) => {
        var source = "notification"
        navigate(`/nujobshome/nujobsViewJobsContainer/${source}/${job.QhCompanyJID}`);
    };

    const handleCancel = (job) => {
        let encodedJsonValues ={};
        //now override keyword and location
        encodedJsonValues.qhoid= job.QhOID;
        encodedJsonValues.qhcompanyjid=job.QhCompanyJID;
        nuJobsDisardIncompleteJd(encodedJsonValues,nuJobsGetIncompleteJds);
    };

    return (
        <div className="nujobs-notifications">
            <div className="notifications-header">
                <p>Your Notifications</p>
            </div>

            <div className="notifications-wrapper">

                {incompleteJDs?.length === 0 || incompleteJDs === undefined || incompleteJDs==null? (
                    <Empty description="No notifications" />
                ) : (
                    <List
                        dataSource={incompleteJDs}
                        renderItem={(job) => (
                            <List.Item className="incomplete-job-notification">

                                <div className="notification-job-content">

                                    <div className="notification-company-logo">
                                        <img
                                            src={job.companyLogo}
                                            alt="Company Logo"
                                            onError={(e) => {
                                                e.currentTarget.src =
                                                    "/images/company-default.png";
                                            }}
                                        />
                                    </div>

                                    <div className="notification-job-details">
                                        <div className="notification-job-title">
                                            {job.JDDetails.Title}
                                        </div>

                                        <div className="notification-job-id">
                                            Job ID: {job.QhCompanyJID}
                                        </div>

                                        <div className="notification-message">
                                            Your application for this job is incomplete.
                                        </div>
                                    </div>

                                    <div className="notification-actions">

                                        <Button
                                            type="primary"
                                            onClick={() => handleViewJob(job)}
                                            style={{fontWeight:"bold"}}
                                        >
                                            Continue Applying
                                        </Button>

                                        <Button
                                            onClick={() => handleCancel(job)}
                                            style={{fontWeight:"bold"}}
                                        >
                                            Discard
                                        </Button>

                                    </div>

                                </div>

                            </List.Item>
                        )}
                    />
                )}

            </div>
        </div>
    );
}

export default NuJobsNotifications;